import { graphql, HttpResponse } from 'msw'
import { type EnrollmentGetStartedData, type EnrollmentGetStartedSubmitOutput } from '../../../models'

export const getEnrollmentGetStartedDataMock: EnrollmentGetStartedData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/mode-selection',
}

export const submitEnrollmentGetStartedDataMock: EnrollmentGetStartedSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/account-name',
}

export const mockGetEnrollmentGetStartedData = graphql.mutation('getEnrollmentGetStartedData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentGetStartedDataMock } })
})

export const mockSubmitEnrollmentGetStartedData = graphql.mutation('submitEnrollmentGetStartedData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentGetStartedDataMock } })
})

export const mockEnrollmentGetStarted = [mockGetEnrollmentGetStartedData, mockSubmitEnrollmentGetStartedData]
